<template>
  <div>
    <div>
      <div class="alert remover" v-show="!!errorMessage">
        <a href="#" class="close" @click="errorMessage = null">&times;</a>
        Falha ao Salvar alterações:<br />
        <p>{{ errorMessage }}</p>
      </div>
      <div class="mt-2 mb-2">
        <CAlert color="warning" :show="true">
          <strong>O upload de imagens tem persistência imediata</strong> — a imagem é salva
          automaticamente ao ser enviada, sem necessidade de clicar em Salvar.
          <br />
          Para que a imagem principal funcione corretamente, o nome da imagem
          deverá ser o mesmo código do produto. Caso contrário, será considerada secundária.
          Exemplo: código do produto:
          <strong>{{ item.id }}</strong>, nome da imagem: <strong>{{ item.id }}.jpg</strong>
        </CAlert>
      </div>
    </div>
    <div>
      <label class="button success" :class="{ disabled: uploading }">
        {{ uploadLabel }}
        <input
          type="file"
          name="image"
          style="display: none"
          accept="image/jpg, image/jpeg, image/png"
          multiple
          @change="onUpload"
          :disabled="uploading"
        />
      </label>
    </div>
    <div class="d-flex flex-wrap">
      <div v-for="imagem in imagens" :key="imagem" class="col-4">
        <div class="thumbnail BorderActive">
          <div class="subtitle">
            <strong class="small dark">{{ imagem | baseName }}</strong>
          </div>
          <div class="LogoimgBox">
            <img :src="imagem" />
          </div>
          <div class="caption">
            <div class="caption__actions">
              <label class="button error" @click="remove(imagem)">
                Excluir
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="section-label">Vídeos YouTube</div>
    <div class="form-group">
      <label class="field-label">Códigos dos vídeos (separados por vírgula)</label>
      <CInput
        v-model="item.videos"
        placeholder="Ex: dQw4w9WgXcQ, 9bZkp7q19f0"
      />
    </div>
    <VideoGallery
      v-if="videoIds.length > 0"
      :videoIds="videoIds"
    />
    <p v-else class="text-muted small">Nenhum vídeo cadastrado.</p>
  </div>
</template>

<script>
import VideoGallery from "@/components/video/VideoGallery";

export default {
  name: "Imagens",
  components: { VideoGallery },
  props: ["item", "imagens", "remove", "upload", "errorMessage", "uploading", "uploadLabel"],
  methods: {
    onUpload(event) {
      this.upload(event);
    },
  },
  computed: {
    videoIds() {
      if (!this.item.videos) return [];
      return this.item.videos
        .split(",")
        .map((v) => v.trim())
        .filter((v) => v.length > 0);
    },
  },
  mounted() {
    this.$nextTick(() => {
      const gallery = this.$children.find(
        (c) => c.$options.name === "VideoGallery" || c.fetchVideoData
      );
      if (gallery && gallery.fetchVideoData) {
        gallery.loaded = true;
        gallery.fetchVideoData();
      }
    });
  },
};
</script>

<style scoped>
.section-label {
  font-size: 11px;
  font-weight: 700;
  color: #888;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin: 20px 0 8px;
  padding-top: 12px;
  border-top: 1px solid #e9ecef;
}

.field-label {
  font-size: 11px;
  font-weight: 600;
  color: #667085;
  text-transform: uppercase;
  letter-spacing: 0.3px;
  margin-bottom: 3px;
  display: block;
}

.form-group {
  margin-bottom: 12px;
}

.add-image {
  margin-bottom: 10px;
}

.button.disabled {
  opacity: 0.6;
  cursor: not-allowed;
}
</style>
